"use client";

import LabelInput from "@/components/label";
import styled from "styled-components";

export const CheckInput = styled.input`
  &[type="checkbox"] {
    display: none;
  }
`;

export const LabelCheck = styled(LabelInput)`
  position: relative;
  padding-left: 28px;
  cursor: pointer;

  ${CheckInput} + &:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid var(--borderColor);
    border-radius: 3px;
    left: 0;
    transition: 0.3s;
  }

  ${CheckInput}:checked + &:before {
    background: var(--primarySystem100);
  }

  ${CheckInput} + &:after {
    content: "✔";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    left: 0;
    top: 0;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: 0.3s;
    color: #fff;
  }

  ${CheckInput}:checked + &:after {
    opacity: 1;
  }
`;

export const BoxCheckInput = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const LinkLabel = styled.a`
  color: var(--primarySystem100);
  text-decoration: none;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: var(--primarySystem300);
  }
`;
